var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tickIcon",on:{"click":_vm.tickClicked}},[_c('input',{attrs:{"type":"checkbox","id":"check","checked":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":"check"}},[_c('div',{staticClass:"check-icon"})])
}]

export { render, staticRenderFns }